import axios from './axiosConfig'; // Axios avec gestion auto du refresh token
import NotificationService from './NotificationService';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api`;

class AppearanceService {
  /**
   * Récupérer la configuration d'apparence de la boutique
   * @returns {Promise<Object|null>} Les données d'apparence ou null
   * @throws {Error} Erreur avec response.status pour les erreurs 401/403
   */
  static async getShopAppearance() {
    try {
      const response = await axios.get(`${API_URL}/shop/appearance`);
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors du chargement de l\'apparence:', error);
      
      // Propager les erreurs d'authentification pour permettre une gestion spécifique
      if (error.response?.status === 401 || error.response?.status === 403) {
        throw error;
      }
      
      // Pour les autres erreurs, retourner null (comportement gracieux)
      return null;
    }
  }

  /**
   * Sauvegarder la configuration d'apparence de la boutique
   * @param {Object} appearanceData - Les données d'apparence à sauvegarder
   * @returns {Promise<Object>} Les données sauvegardées
   * @throws {Error} Erreur en cas d'échec
   */
  static async saveShopAppearance(appearanceData) {
    try {
      const response = await axios.post(`${API_URL}/shop/appearance`, appearanceData);
      NotificationService.success('Configuration de l\'apparence sauvegardée avec succès');
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors de la sauvegarde de l\'apparence:', error);
      
      // Ne pas afficher de notification pour les erreurs auth (gérées par le composant)
      if (error.response?.status !== 401 && error.response?.status !== 403 && error.response?.status !== 409 && error.response?.status !== 429) {
        NotificationService.error('Erreur lors de la sauvegarde de l\'apparence');
      }
      
      throw error;
    }
  }

  /**
   * Mettre à jour la configuration d'apparence de la boutique
   * @param {Object} appearanceData - Les données d'apparence à mettre à jour
   * @returns {Promise<Object>} Les données mises à jour
   * @throws {Error} Erreur en cas d'échec
   */
  static async updateShopAppearance(appearanceData) {
    try {
      const response = await axios.post(`${API_URL}/shop/appearance/update`, appearanceData);
      NotificationService.success('Configuration de l\'apparence mise à jour avec succès');
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'apparence:', error);
      
      // Ne pas afficher de notification pour les erreurs auth (gérées par le composant)
      if (error.response?.status !== 401 && error.response?.status !== 403 && error.response?.status !== 409 && error.response?.status !== 429) {
        NotificationService.error('Erreur lors de la mise à jour de l\'apparence');
      }
      
      throw error;
    }
  }
}

export default AppearanceService;
